/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, IconButton, Text } from '@chakra-ui/react';
import { useFormState } from 'react-final-form';
import styled from '@emotion/styled';
import { every, flatMap } from 'lodash-es';
import {
  DetailsService,
  InfoIcon,
  InfoService,
  ModalPage,
  Paper,
} from 'components';
import { getServicesDuration } from 'utils';
import { FormValues, ServiceGroupsInfo } from 'types';
import { TitleStlyed } from './styles';
import { Time } from './Time';

const PaperStyled = styled(Paper)`
  padding: 0;
`;

const BoxStyled = styled(Box)`
  padding: 16px;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayBorder};
  }
`;

export const Services: React.FC<{
  address: string;
  serviceGroups: ServiceGroupsInfo;
  widgetId?: string;
  favorId?: string;
  date?: Date;
}> = ({ address, serviceGroups, widgetId, favorId, date }) => {
  const {
    values: { favorIds, favorCounts },
  } = useFormState<FormValues>();
  const serviceIds = favorId ? [favorId] : favorIds;

  const services = flatMap(serviceGroups).filter((service) =>
    serviceIds.includes(service.id),
  );

  const [itemId, setItemId] = React.useState<string | null>(null);
  const resetItemId = () => setItemId(null);
  const item = services.find(({ id }) => id === itemId);

  const isShowDuration = every(
    services,
    (service) => service.showDuration !== false,
  );
  const duration = isShowDuration
    ? getServicesDuration(serviceGroups, serviceIds, favorCounts)
    : 0;

  return (
    <>
      <ModalPage isOpen={!!item} title="Об услуге" onClose={resetItemId}>
        {!!item && <DetailsService service={item} widgetId={widgetId} />}
      </ModalPage>
      <Paper my="4">
        <Time duration={duration} day={date} />
        {address && (
          <Box mt={2}>
            <TitleStlyed>Адрес</TitleStlyed>
            <div translate="no">{address}</div>
          </Box>
        )}
      </Paper>

      <Text color="black" textStyle="h4" mt={4} mb={2}>
        Услуги
      </Text>
      <PaperStyled>
        {services.map((service) => (
          <BoxStyled
            key={service.id}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <div>
              <InfoService service={service} showCount />
            </div>
            <IconButton
              rounded="full"
              variant="ghost"
              icon={<InfoIcon />}
              aria-label="Назад в выбор услуг"
              onClick={(e) => {
                setItemId(service.id);
                e.stopPropagation();
              }}
            />
          </BoxStyled>
        ))}
      </PaperStyled>
    </>
  );
};
